module.exports = __webpack_public_path__ + "img/vegetarian.20c2813e.jpg";